<template>
  <div class="p-0">
    <div class="position-absolute;" style="z-index:1; width: -webkit-fill-available;">
      <vue-tags-input
        v-model="tag"
        placeholder=""
        :add-from-paste="false"
        :autocomplete-items="allTags"
        :separators="[',', ';']"
        :tags="tags"
        class="border"
        style="max-width: unset;"
        @tags-changed="tagUpdateEvent">
      </vue-tags-input>
    </div>
  </div>
</template>
<script>
import debounce from 'lodash/debounce';
import VueTagsInput from '@johmun/vue-tags-input';

export default {
  components: {
    VueTagsInput,
  },
  props: {
    network_media_id: {
      type: [String, Number],
      default: null,
    },
    network_media_collection_id: {
      type: [String, Number],
      default: null,
    },
    course_id: {
      type: [String, Number],
      default: null,
    },
  },
  data() {
    return {
      tag: '',
      tags: [],
      allTags: []
    };
  },
  watch: {
    tag: debounce(function (newTag) {
      this.searchTags(newTag);
    }, 600),
  },
  methods: {
    tagUpdateEvent(newTags) {
      if (this.network_media_id) {
        this.$http.get('networks/media/tags/' + this.network_media_id).then(response => {
          newTags.forEach(a => {
            if (!response.data.data.find(tag => tag.name === a.text)) {
              this.$http.post('networks/media/tag/add', { tag : a, network_media_id : this.network_media_id }).then(resp => {
                if(resp.data != ''){
                  this.$emit('update-media-tags');
                }
              });
            }
          });
        });
      } else if (this.network_media_collection_id) {
        this.$http.get('networks/collections/tags/' + this.network_media_collection_id).then(response => {
          newTags.forEach(a => {
            if (!response.data.data.find(tag => tag.name === a.text)) {
              this.$http.post('networks/collections/tag/add', { tag : a, network_media_collection_id : this.network_media_collection_id }).then(resp => {
                if(resp.data != ''){
                  this.$emit('update-collection-tags');
                }
              });
            }
          });
        });
      } else if (this.course_id) {
        this.$http.get('courses/tags/' + this.course_id).then(response => {
          newTags.forEach(a => {
            if (!response.data.data.find(tag => tag.name === a.text)) {
              this.$http.post('courses/tag/add', { tag : a, course_id : this.course_id }).then(resp => {
                if(resp.data != ''){
                  this.$emit('update-course-tags');
                }
              });
            }
          });
        });
      }
      this.tags.splice(0);
    },
    searchTags(tagQuery) {
      if (tagQuery.length > 0)
        this.$http.get('tags?limit=20&query=' + tagQuery).then(resp => {
          this.allTags = resp.data.map(a => {
            return { id: a.id, text: a.name };
          });
        });
    },
  },
};
</script>
